import { FunctionComponent, useEffect, useState } from "react";
import { useOrderCreateCtx } from "../../../../../../context_providers/order_create_context";
import {
  useToast,
  ToastType,
} from "../../../../../../context_providers/toast/toast_ctx";
import { AddressModel } from "../../../../../../service/models/address_model";
import { CustomerDetailModel } from "../../../../../../service/models/orders/customer_detail_model";
import { CreateBillingProfileApi } from "../../../../../../service/repos/customer/billing_profile_repo";
import { AddressType, OrderType } from "../../../../../../utils/enums";
import LoadingWidget from "../../../../../components/loading_spinner";
import {
  ModalAlignment,
  ModalType,
  useModal,
} from "../../../../../../context_providers/modal/modal_context";
import AddressPickerWidget from "../../../../../new_components/common/location/AddressPicker";

interface AddBillingProfileWidgetProps {
  user_id: any;
  onAdded: (data: CustomerDetailModel) => void;
  id_prefix?: string;
}
const defaultAddress: AddressModel = {
  type: AddressType.HOME,
  line1: "",
  city: "",
  state: "",
  country: "India",
  pincode: 0,
};
const defaultValue: CustomerDetailModel = {
  firstName: "",
  mobile: "",
  alt_mobile: "",
  email: "",
  address: defaultAddress,
  first_name: "",
  last_name: "",
  email_verified: false,
  mobile_verified: false,
  active: false,
};
const AddBillingProfileWidget: FunctionComponent<
  AddBillingProfileWidgetProps
> = ({ onAdded, user_id, id_prefix = "billing-profile" }) => {
  const { order, user } = useOrderCreateCtx();
  const { showToast } = useToast();
  const { showModal, onClose } = useModal();
  const [customer, setCustomer] = useState<CustomerDetailModel>({
    ...defaultValue,
    user_id,
  });
  const [loading, setLoading] = useState(false);

  const createBillingProfile = async () => {
    setLoading(true);
    customer.firstName = customer.firstName.trim();
    customer.lastName = customer.lastName?.trim();
    customer.mobile = customer.mobile.trim();
    customer.email = customer.email.trim();
    const res = await CreateBillingProfileApi(customer!);
    if (res.success) {
      showToast({ type: ToastType.success, text: "Created Successfull !" });
      setLoading(false);
      return onAdded(res.data);
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }
    setLoading(false);
  };

  useEffect(() => {
    setCustomer((o) => ({
      ...o,
      firstName: user!.first_name,
      lastName:
        order.type === OrderType.B2C || order.type === OrderType.DELHI_TENDOR
          ? user!.last_name
          : "",
      mobile: user!.mobile ?? "",
      email: user!.email ?? "",
    }));
  }, []);
  return (
    <>
      <form
        id={`${id_prefix}-form`}
        onSubmit={(e) => {
          e.preventDefault();
          createBillingProfile();
        }}
        className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm"
      >
        <div className="flex flex-col gap-2 ">
          {" "}
          <h3 className="text-sm font-semibold">Customer detail</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-first-name`}>
              {order.type === OrderType.B2C ||
              order.type === OrderType.DELHI_TENDOR
                ? "First Name"
                : "Business Name"}
              <span className="text-red-400">*</span>
            </label>
            <input
              id={`${id_prefix}-first-name`}
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              type="text"
              name="firstName"
              placeholder={
                order.type === OrderType.B2C ||
                order.type === OrderType.DELHI_TENDOR
                  ? "First Name"
                  : "Business name"
              }
              value={customer.firstName}
              onChange={(e) =>
                setCustomer((o) => ({
                  ...o!,
                  firstName: e.target.value,
                }))
              }
              required
            />
          </div>
          {(order.type === OrderType.B2C ||
            order.type === OrderType.DELHI_TENDOR) && (
            <div className="grid grid-cols-1 md:grid-cols-3 items-center">
              <label htmlFor={`${id_prefix}-last-name`}>Last Name</label>
              <input
                id={`${id_prefix}-last-name`}
                className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
                type="text"
                name="lastName"
                // required
                value={customer?.lastName}
                onChange={(e) =>
                  setCustomer((o) => ({
                    ...o!,
                    lastName: e.target.value,
                  }))
                }
                placeholder={"Last Name"}
              />
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-mobile`}>
              Mobile <span className="text-red-400">*</span>
            </label>
            <input
              required
              type="tel"
              pattern="[1-9]{1}[0-9]{9}"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none "
              id={`${id_prefix}-mobile`}
              value={customer?.mobile}
              placeholder="10 Digits"
              onChange={(e) =>
                setCustomer((o) => ({ ...o!, mobile: e.target.value.trim() }))
              }
              title="Please enter 10 digit mobile number"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-alt-mobile`}>Alternate Mobile </label>
            <input
              type="tel"
              pattern="[1-9]{1}[0-9]{9}"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none "
              id={`${id_prefix}-alt-mobile`}
              placeholder="10 Digits"
              value={customer?.alt_mobile}
              onChange={(e) =>
                setCustomer((o) => ({
                  ...o!,
                  alt_mobile: e.target.value.trim(),
                }))
              }
              title="Please enter 10 digit mobile number"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-email`}>Email</label>
            <input
              type="text"
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              id={`${id_prefix}-email`}
              placeholder="Valid email address"
              value={customer?.email}
              onChange={(e) =>
                setCustomer((o) => ({ ...o!, email: e.target.value.trim() }))
              }
            />
          </div>
          {(order.type === OrderType.B2B ||
            order.type === OrderType.PARTNER) && (
            <div className="grid grid-cols-1 md:grid-cols-3 items-center">
              <label htmlFor={`${id_prefix}-poc`}>
                Contact person <span className="text-red-400">*</span>
              </label>
              <input
                id={`${id_prefix}-poc`}
                className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
                type="text"
                name="poc"
                required
                placeholder="Contact person name"
                value={customer?.poc}
                onChange={(e) =>
                  setCustomer((o) => ({ ...o!, poc: e.target.value }))
                }
              />
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-gst`}>
              GST number <span className="text-red-400">*</span>
            </label>
            <input
              id={`${id_prefix}-gst`}
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              type="text"
              name="gst"
              // required={
              //   order.type === OrderType.B2B || order.type === OrderType.PARTNER
              // }
              value={customer.gst}
              onChange={(e) =>
                setCustomer((o) => ({ ...o!, gst: e.target.value.trim() }))
              }
              placeholder="GST number"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center">
            <label htmlFor={`${id_prefix}-ca`}>CA number</label>
            <input
              id={`${id_prefix}-ca`}
              className="col-span-2 p-2 rounded bg-gray-100 focus:outline-none"
              type="text"
              name="ca"
              value={customer.ca}
              onChange={(e) =>
                setCustomer((o) => ({ ...o!, ca: e.target.value.trim() }))
              }
              placeholder="CA number"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-semibold">Address</h3>
          <div className="flex">
            <h3 className="text-sm  ">Type</h3>
            {Object.values(AddressType).map((type, i) => {
              const typeId = `${id_prefix}-address-type-${type
                .toLowerCase()
                .replace(/\s+/g, "-")}`;
              return (
                <div className="mx-3" key={i}>
                  <input
                    onChange={(e) => {
                      setCustomer((o) => ({
                        ...o!,
                        address: { ...o?.address, type: type },
                      }));
                    }}
                    className="mx-2"
                    type="radio"
                    checked={customer.address.type === type}
                    name="type"
                    required
                    id={typeId}
                  />
                  <label className=" font-semibold" htmlFor={typeId}>
                    {type}
                  </label>
                </div>
              );
            })}
          </div>
          <div className="flex    flex-col col-span-2">
            <label htmlFor={`${id_prefix}-address-picker`}>Address</label>
            <div
              id={`${id_prefix}-address-picker`}
              onClick={() => {
                showModal({
                  type: ModalType.drawer,
                  title: "Address Picker",
                  alignment: ModalAlignment.right,
                  container(id) {
                    return (
                      <div className="  bg-gray-100 p-1 h-full w-full">
                        <AddressPickerWidget
                          data={customer.address}
                          location_required={false}
                          onSubmit={function (_address: AddressModel): void {
                            setCustomer((o) => ({
                              ...o!,
                              address: { ...o!.address, ..._address },
                            }));
                            onClose(id);
                          }}
                          onCancel={function (): void {
                            onClose(id);
                          }}
                        />
                      </div>
                    );
                  },
                });
              }}
              className="border rounded px-2 p-1 focus:outline-none  h-32 w-96"
            >
              {customer.address.full_address}
            </div>
          </div>
        </div>
        <div className="col-span-2 flex justify-center mt-5">
          <button
            id={`${id_prefix}-submit-btn`}
            className="bg-myPrimaryColor font-semibold text-sm text-white rounded-3xl px-3 py-1 hover:scale-110 transform duration-300"
          >
            Submit
          </button>
        </div>
      </form>
      <LoadingWidget loading={loading} />
    </>
  );
};

export default AddBillingProfileWidget;
